import React from 'react'
import Header from "../../../../Components/Header";
import Brand from './Brand';
import { Helmet } from 'react-helmet';
function EditBrand() {
  return (
    <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
            <Helmet>
				<title>Brand - Edit</title>
			</Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column" style={{flexGrow:'1'}}>
        <Brand />
      </div>
    </div>
  )
}

export default EditBrand
